__turbopack_context__.v({
  "GC": "styles-module-scss-module__b5yAra__GC",
  "SC": "styles-module-scss-module__b5yAra__SC",
  "activeLink": "styles-module-scss-module__b5yAra__activeLink",
  "icon": "styles-module-scss-module__b5yAra__icon",
  "link": "styles-module-scss-module__b5yAra__link",
});
